import { render, staticRenderFns } from "./pointNew.vue?vue&type=template&id=33e144da&scoped=true&"
import script from "./pointNew.vue?vue&type=script&lang=js&"
export * from "./pointNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e144da",
  null
  
)

export default component.exports